import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  categories: () => __(translations.directoryFormUpdate.category, 'Categories'),
  title: () => __(translations.directoryFormUpdate.alertTitle, 'Edit Family'),
};
